import React from 'react';
import IconBase from './IconBase';
import {Tooltip} from 'antd';

const GeneratePostTestIcon = props => {
    const {tooltipprops, iconprops} = {...props}
    return (
        <Tooltip  {...tooltipprops} >
            <span><IconBase {...iconprops} >
                <g id="Group_93" transform="translate(-1766 -987)">
                    <g transform="translate(1771 986)">
                        <path id="Path_80" d="M24.1,17.7c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1l0,0C30.2,20.5,27.5,17.7,24.1,17.7z
			 M26.4,24.6h-1.5v1.5c0,0.4-0.3,0.8-0.7,0.8c-0.4,0-0.8-0.3-0.8-0.7c0,0,0,0,0-0.1v-1.5h-1.5c-0.4,0-0.8-0.3-0.8-0.7
			c0-0.4,0.3-0.8,0.7-0.8c0,0,0,0,0.1,0h1.5v-1.5c0-0.4,0.3-0.8,0.7-0.8c0.4,0,0.8,0.3,0.8,0.7c0,0,0,0,0,0.1v1.5h1.5
			c0.4,0,0.8,0.3,0.8,0.7S26.9,24.6,26.4,24.6C26.4,24.6,26.4,24.6,26.4,24.6L26.4,24.6z"/>
                        <g id="Group_92" transform="translate(3 2)">
                            <path id="Path_81" d="M15.7,5.5v4.1h4.1L15.7,5.5z"/>
                            <path id="Path_82" d="M18.4,11.1H15c-0.4,0-0.7-0.3-0.8-0.7c0,0,0-0.1,0-0.1V5H5.8C5.4,5,5,5.3,5,5.7c0,0,0,0.1,0,0.1v19.9
				c0,0.4,0.3,0.7,0.7,0.8c0,0,0.1,0,0.1,0H15c-1-1.3-1.6-2.9-1.5-4.6c0-3.9,3-7.2,6.9-7.6v-1.2C20.3,12,19.5,11.1,18.4,11.1
				C18.4,11.1,18.4,11.1,18.4,11.1z"/>
                        </g>
                    </g>
                </g>
                <g>
                    <path d="M8.7,38.5v3.4H6.3v-10h4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.2c0.3,0.5,0.5,1.1,0.5,1.8
		c0,1-0.3,1.7-1,2.3c-0.7,0.6-1.6,0.9-2.9,0.9H8.7z M8.7,36.6h1.6c0.5,0,0.8-0.1,1.1-0.3c0.2-0.2,0.4-0.6,0.4-1
		c0-0.5-0.1-0.8-0.4-1.1c-0.2-0.3-0.6-0.4-1-0.4H8.7V36.6z"/>
                    <path d="M23.9,37.1c0,1-0.2,1.8-0.5,2.6c-0.4,0.7-0.9,1.3-1.5,1.7c-0.7,0.4-1.4,0.6-2.3,0.6s-1.6-0.2-2.3-0.6
		c-0.7-0.4-1.2-0.9-1.5-1.7c-0.4-0.7-0.6-1.6-0.6-2.5v-0.6c0-1,0.2-1.8,0.5-2.6c0.4-0.7,0.9-1.3,1.5-1.7c0.7-0.4,1.4-0.6,2.3-0.6
		c0.8,0,1.6,0.2,2.3,0.6c0.7,0.4,1.2,1,1.5,1.7c0.4,0.7,0.6,1.6,0.6,2.5V37.1z M21.4,36.7c0-1-0.2-1.7-0.5-2.3
		c-0.3-0.5-0.8-0.8-1.4-0.8c-1.2,0-1.8,0.9-1.9,2.7l0,0.7c0,1,0.2,1.7,0.5,2.2c0.3,0.5,0.8,0.8,1.4,0.8c0.6,0,1.1-0.3,1.4-0.8
		s0.5-1.3,0.5-2.2V36.7z"/>
                    <path d="M30.2,39.2c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.2-0.7-0.4-1.3-0.6c-0.6-0.2-1.1-0.4-1.5-0.6
		c-1.3-0.6-1.9-1.5-1.9-2.6c0-0.6,0.2-1,0.5-1.5c0.3-0.4,0.8-0.7,1.4-1c0.6-0.2,1.2-0.4,2-0.4c0.7,0,1.4,0.1,1.9,0.4
		c0.6,0.3,1,0.6,1.3,1.1c0.3,0.5,0.5,1,0.5,1.6h-2.4c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3c-0.4,0-0.8,0.1-1,0.3
		c-0.2,0.2-0.4,0.4-0.4,0.7c0,0.3,0.1,0.5,0.4,0.7c0.3,0.2,0.8,0.4,1.4,0.6c0.7,0.2,1.3,0.5,1.7,0.7c1.1,0.6,1.6,1.5,1.6,2.6
		c0,0.9-0.3,1.6-1,2.1S30.1,42,28.9,42c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.1-0.7-1.5-1.2c-0.3-0.5-0.5-1.1-0.5-1.7h2.4
		c0,0.5,0.1,0.9,0.4,1.2c0.3,0.3,0.7,0.4,1.3,0.4c0.4,0,0.7-0.1,0.9-0.3C30.1,39.8,30.2,39.5,30.2,39.2z"/>
                    <path d="M41.7,33.8h-3v8.1h-2.4v-8.1h-2.9v-1.9h8.3V33.8z"/>
                </g>
            </IconBase></span>
        </Tooltip>
    )
}

export default GeneratePostTestIcon;
